import logo from './logo.svg';
import './App.css';
import { Route, Routes, useNavigate } from 'react-router-dom';
import User from './components/user/User';
import Login from './components/user/pages/Login';
import ForgetPassword from './components/user/pages/ForgetPassword';
import ResetPassword from './components/user/pages/ResetPassword';
import StaffList from './components/user/pages/StaffList';
import Overview from './components/user/pages/Overview';
import StaffDetail from './components/user/pages/StaffDetail';
import EditStaff from './components/user/pages/EditStaff';
import AddStaff from './components/user/pages/AddStaff';
import Setting from './components/user/pages/Setting';
import EditProfile from './components/user/pages/EditProfile';
import FundRequest from './components/user/pages/FundRequest';
import AddFundRequest from './components/user/pages/AddFundRequest';
import TransferOption from './components/user/pages/TransferOption';
import QRCode from './components/user/pages/QRCode';
import BankdTransfer from './components/user/pages/BankTransfer';
import CardSuccess from './components/user/pages/CardSuccess';
import ChargingReport from './components/user/pages/ChargingReport';
import FundRequestDetail from './components/user/pages/FundRequestDetail';
import StaffReport from './components/user/pages/StaffReport';
import { useEffect, useState } from 'react';
import DisabledAccount from './components/user/pages/DisabledAccount';
import ByPoints from './components/user/pages/ByPoints';
import TransferReport from './components/user/pages/TransferReport';

function App() {
  const navigate = useNavigate();
  const [amount, setAmount] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("user_token");
    // console.log("token : ", token)
    if(!token){
      navigate('/login');
    }  
  }, [])
  
  return (
    <>
      <Routes>
        <Route path='/login' element={<Login />} />
        <Route path='/forget-password' element={<ForgetPassword />} />
        <Route path='/reset-password' element={<ResetPassword />} />
        <Route path='/disabled-account' element={<DisabledAccount />} />
        <Route path="/" element={<User />} >
          <Route index element={<Overview />} />
          <Route path="vcards" element={<StaffList />} />
          <Route path="vcard-detail/:id" element={<StaffDetail />} />
          <Route path="vcard/edit/:id" element={<EditStaff />} />
          <Route path="vcard/add" element={<AddStaff />} />
          <Route path="setting" element={<Setting />} />
          <Route path="setting/edit/:id" element={<EditProfile />} />
          <Route path="fund-requests" element={<FundRequest />} />
          <Route path="fund-requests/add" element={<AddFundRequest amount={amount} setAmount={setAmount} />} />
          <Route path="fund-requests/add/transfer" element={<TransferOption setAmount={setAmount} amount={amount} />} />
          <Route path="fund-requests/add/transfer/qr-code" element={<QRCode />} />
          <Route path="fund-requests/add/transfer/bank-transfer" element={<BankdTransfer />} />
          <Route path="fund-requests/add/transfer/card" element={<CardSuccess />} />
          <Route path='charging-report' element={<ChargingReport />} />
          <Route path='transfer-report' element={<TransferReport />} />
          <Route path='fund-requests/detail/:id' element={<FundRequestDetail />} />
          <Route path='vcard-report/:id' element={<StaffReport />} />
          <Route path='buy-points' element={<ByPoints />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
